import * as api from '../../api/api'
// initial state
const state = {  
  selectedItem: null, // 选中的item
  items: [],
}

// getters
const getters = {
}

// mutations
const mutations = {
  selectShippingItem(state, item) {
    const { selectedItem } = state
    if (selectedItem) {
      if (selectedItem.id !== item.id) {
        state.selectedItem = item
      }
    } else {
      if (item) {
        state.selectedItem = item
      }
    }
  },
  saveShippingItems(state, items) {
    state.items = items
  }  
}

// actions 
const actions = {
  fetchShippingList({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      let data = {
        shop: params.shop,
        products: params.products,
        address: params.address,
        activity_mark: params.activity_mark,
        score_exchange: params.score_exchange
      }
      api.shippingVendorList(data).then(
        (response) => {
          if (response && response.vendors) {
            let items = response.vendors
            commit('saveShippingItems', items)
            const { selectedItem } = state
            if (selectedItem === null || selectedItem === undefined ||!(items.some(user => user.name === selectedItem.name))) {
              if (items.length) {
                commit('selectShippingItem', items[0])
              }
            }
            resolve(response)
          }
        }, (error) => {
          reject(error)
        }) 
    })   
  }
}

export default {  
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/shipping.js